import React, { useEffect, useState } from "react";

const Check = ({ value = false , onChange, label="", className="", name="", id="", required=false }) => {
  const [innerValue, setInnerValue] = useState(value);

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  const handleChange = (e) => {
    setInnerValue(!innerValue);
    if (onChange) {
      onChange(!value);
    }
  };

  return (
    <>
      <label htmlFor={name}>{label}</label>
      <input
        id={id}
        className={className}
        name={name}
        type="checkbox"
        checked={innerValue}
        onChange={handleChange}
        required={required}
      />
    </>
  );
};

export default Check;
